export const VideoSection = ({ url, header }) => {
   return (
      <div className='video-section'>
         {header&&<h1>{header}</h1>}
         <section >
            <div>
               <iframe width="100%" height="100%" src={url} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
            </div>
         </section>
      </div>
   );
}

